import { UrlParam } from 'enums';
import { getParamsFromUrl } from 'utils';

export const getIdFromUrl = (search: string) =>
  getParamsFromUrl<string>({ search: search, param: UrlParam.ID, defaultValue: '' });
